export default "__VITE_ASSET__DsFjqfAt__"